export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11339.681ed4b0.jpg";